import { Trophy, Circle, Minus } from "lucide-react";

/**
 * Badge for Athlete.activity_type — Agonista / Non agonista / Non impostato.
 *
 * Rule (from product spec): "Non utilizzare il colore come unico veicolo
 * dell'informazione". We combine an icon (semantic shape) + text label +
 * discreet accent color coherent with the design system.
 *
 *  - agonista       → Trophy icon,  emerald tint, "Agonista"
 *  - non_agonista   → Circle icon,  zinc tint,    "Non agonista"
 *  - null/undefined → Minus icon,   dashed border,"— Non impostato"
 */
export default function ActivityBadge({ value }) {
  if (value === "agonista") {
    return (
      <span data-testid="activity-badge-agonista" className="inline-flex items-center gap-1 text-[11px] tracking-wider px-2 py-1 border border-emerald-200 bg-emerald-50 text-emerald-800 rounded">
        <Trophy className="w-3 h-3" aria-hidden="true" />
        <span>Agonista</span>
      </span>
    );
  }
  if (value === "non_agonista") {
    return (
      <span data-testid="activity-badge-non-agonista" className="inline-flex items-center gap-1 text-[11px] tracking-wider px-2 py-1 border border-zinc-200 bg-zinc-50 text-zinc-700 rounded">
        <Circle className="w-3 h-3" aria-hidden="true" />
        <span>Non agonista</span>
      </span>
    );
  }
  return (
    <span data-testid="activity-badge-unset" className="inline-flex items-center gap-1 text-[11px] tracking-wider px-2 py-1 border border-dashed border-zinc-300 text-zinc-400 rounded italic">
      <Minus className="w-3 h-3" aria-hidden="true" />
      <span>Non impostato</span>
    </span>
  );
}
